import Theme from 'Theme';

export const PENDING = 'PENDING';
export const INVALID = 'INVALID';
export const COMPLETE = 'COMPLETED';
export const IN_PROGRESS = 'IN PROGRESS';

export const UPDATE_PENDING = 'UPDATE PENDING';
export const UPDATE_INVALIDATED = 'UPDATE INVALIDATED';


export const DOC_TYPE_TITLE = 'TITLE';
export const SERVICE_FEE = 'Service Fee';
export const CREDIT_CARD_SURCHARGE = 'Credit Card Surcharge';

export const FILTER_BY_ADDRESS = 'FILTER_BY_ADDRESS';
export const FILTER_BY_FILE = 'FILTER_BY_FILE';
export const FILTER_BY_USER = 'FILTER_BY_USER';

export const FORM1 = 'FORM1';
export const STRATA = 'STRATA_SEARCH';
export const COUNCIL_SEARCH = 'COUNCIL_SEARCH';

export const STATUS_TEXT = {
  [PENDING]: 'Pending',
  [INVALID]: 'Invalid',
  [COMPLETE]: 'Completed',
  [IN_PROGRESS]: 'In Progress',
  [UPDATE_PENDING]: "Update Requested",
  [UPDATE_INVALIDATED]: "Update Invalidated",
};

export const COLORS = {
  [PENDING]: Theme.warningColor,
  [INVALID]: Theme.dangerColor,
  [COMPLETE]: Theme.successColor,
  [IN_PROGRESS]: Theme.brandColor,
  [UPDATE_PENDING]: Theme.brandColor,
  [UPDATE_INVALIDATED]: Theme.dangerColor,
};

export const LIGHT_COLORS = {
  [PENDING]: Theme.warningColorLight,
  [INVALID]: Theme.dangerColorLight,
  [COMPLETE]: Theme.successColorLight,
  [IN_PROGRESS]: Theme.brandColorLight,
  [UPDATE_PENDING]: Theme.brandColorLight,
  [UPDATE_INVALIDATED]: Theme.dangerColorLight,
};
